import { render } from "./DashboardHero.vue?vue&type=template&id=046626ed&scoped=true"
import script from "./DashboardHero.vue?vue&type=script&lang=js"
export * from "./DashboardHero.vue?vue&type=script&lang=js"

import "./DashboardHero.vue?vue&type=style&index=0&id=046626ed&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046626ed"]])

export default __exports__